// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3DBl6","title":"Info_title__IwJ8Z","links":"Info_links__2B2qn","link":"Info_link__3_3Er","logo":"Info_logo__1aK0L"};